import React, { useContext, createContext, useState } from 'react'
import { apiGet } from '~/util/api'
import {
  QueryClient,
  QueryClientProvider,
  useQuery,
} from '@tanstack/react-query'

const CustomActionPlanContext = createContext()

export const useCustomActionPlan = () => {
  return useContext(CustomActionPlanContext)
}
export const queryClient = new QueryClient()

const CustomActionPlanProviderInner = ({ children }) => {
  const candidateId = location.pathname.split('/').pop()
  const [resourceLibraryIsOpen, setResourceLibraryIsOpen] = useState(false)
  const get_tracker_sections_query = () =>
    apiGet(
      `/coach/candidates/${candidateId}/tracker/get_tracker_sections.json`,
    ).then((res) => res.data)
  const { error: trackerError, data } = useQuery({
    queryKey: ['get_tracker_sections', candidateId],
    queryFn: get_tracker_sections_query,
  })

  const get_all_resources_query = () =>
    apiGet(`/coach/candidates/${candidateId}/all_resources.json`).then(
      (res) => res.data,
    )
  const {
    isLoading,
    error: resourceError,
    data: resources,
  } = useQuery({
    queryKey: ['resource_library', candidateId],
    queryFn: get_all_resources_query,
  })

  if (resourceError) {
    console.error('error retrieving resource library', resourceError)
  }

  const trackerSectionInfo = data?.trackerSectionInfo || []
  const progressPercent = data?.progressPercent || 0
  const goal = data?.goal || ''
  const timeline = data?.timeline || ''

  if (trackerError) {
    console.error('Error retrieving tracker sections:', trackerError)
    return null
  }

  const value = {
    trackerSectionInfo,
    progressPercent,
    goal,
    timeline,
    candidateId,
    resourceLibraryIsOpen,
    setResourceLibraryIsOpen,
    isLoading,
    resources: resources || [],
  }

  return (
    <CustomActionPlanContext.Provider value={value}>
      {children}
    </CustomActionPlanContext.Provider>
  )
}

export const CustomActionPlanProvider = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <CustomActionPlanProviderInner>{children}</CustomActionPlanProviderInner>
    </QueryClientProvider>
  )
}
